/**
 * Подпись расчётного периода выплаты продавцу.
 *
 * С октября 2026 выплаты два раза в месяц (правки ЛК продавца 16.10): период
 * приходит ключом `YYYY-MM-1` (1-15 число) или `YYYY-MM-2` (16-последнее).
 * Старые заявки остаются месячными - ключ `YYYY-MM`.
 */
const MONTHS_GENITIVE = [
	"января",
	"февраля",
	"марта",
	"апреля",
	"мая",
	"июня",
	"июля",
	"августа",
	"сентября",
	"октября",
	"ноября",
	"декабря",
];

export const payoutPeriodLabel = (period: string): string => {
	const [y, m, half] = period.split("-").map(Number);
	const year = y ?? 1970;
	const month = m ?? 1;
	if (half === 1 || half === 2) {
		const last = new Date(Date.UTC(year, month, 0)).getUTCDate();
		const days = half === 1 ? "1-15" : `16-${last}`;
		return `${days} ${MONTHS_GENITIVE[month - 1]} ${year}`;
	}
	return new Date(Date.UTC(year, month - 1, 1)).toLocaleDateString("ru-RU", {
		month: "long",
		year: "numeric",
	});
};
